// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"b5388274","425":"20fb6f24","510":"a5522388","532":"414d80e7","633":"cc643a1b","634":"3be1c0e0","922":"f5d247d1","937":"193f82f9","972":"853c69af"}[chunkId] + ".chunk.js";
};